<div class="wrapper">
  <header class="header">
    <nav class="vam-navbar">
      <div class="container">
        <div class="vam_login_nav">
          <div class="vam_nav_brand">
            <a class="navbar-brand d-flex align-items-center company-logo" routerLink="/">
              <img src="/assets/images/logo.png" alt="Logo" width="30px" height="30px" />
            </a>
          </div>
          <div class="topnav_left_container">
            <a href="javascript:void(0)" class="header-action-link">
              <svg
                width="50"
                height="50"
                viewBox="0 0 102 102"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="51"
                  cy="51"
                  r="51"
                  [attr.fill]="isDeviceOnline ? primaryColor : '#00000026'"
                />
                <path
                  d="M39.7 56.7L35.5 52.4C37.5667 50.3333 39.9333 48.75 42.6 47.65C45.2667 46.55 48.0667 46 51 46C53.9333 46 56.742 46.5587 59.426 47.676C62.11 48.7933 64.468 50.4013 66.5 52.5L62.3 56.7C60.8 55.2 59.0747 54.042 57.124 53.226C55.1733 52.41 53.132 52.0013 51 52C48.868 51.9987 46.8267 52.4073 44.876 53.226C42.9253 54.0447 41.2 55.2027 39.7 56.7ZM31.2 48.2L27 44C30.1667 40.7667 33.8253 38.2913 37.976 36.574C42.1267 34.8567 46.468 33.9987 51 34C55.532 34.0013 59.874 34.86 64.026 36.576C68.178 38.292 71.836 40.7667 75 44L70.8 48.2C68.1667 45.5667 65.1413 43.542 61.724 42.126C58.3067 40.71 54.732 40.0013 51 40C47.268 39.9987 43.6927 40.7073 40.274 42.126C36.8553 43.5447 33.8307 45.5693 31.2 48.2ZM51 68L43.95 60.9C44.8833 59.9667 45.9587 59.25 47.176 58.75C48.3933 58.25 49.668 58 51 58C52.332 58 53.6073 58.25 54.826 58.75C56.0447 59.25 57.1193 59.9667 58.05 60.9L51 68Z"
                  fill="white"
                />
              </svg>
            </a>

            <div class="header-action-container" (click)="goToConnectivityTestRoute()">
              <div class="header-action-icon-container">
                <svg
                  width="50"
                  height="50"
                  viewBox="0 0 102 102"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="51"
                    cy="51"
                    r="51"
                    [attr.fill]="isDeviceOnline ? primaryColor : '#00000026'"
                  />
                  <path
                    d="M51.0001 47.5714C55.2323 47.5714 59.1876 47.1875 62.8662 46.4196C66.5448 45.6518 69.4466 44.5179 71.5716 43.0179V47.5714C71.5716 48.8036 70.6519 49.9464 68.8126 51C66.9734 52.0536 64.4734 52.8884 61.3126 53.5045C58.1519 54.1205 54.7144 54.4286 51.0001 54.4286C47.2859 54.4286 43.8484 54.1205 40.6876 53.5045C37.5269 52.8884 35.0269 52.0536 33.1876 51C31.3484 49.9464 30.4287 48.8036 30.4287 47.5714V43.0179C32.5537 44.5179 35.4555 45.6518 39.1341 46.4196C42.8126 47.1875 46.768 47.5714 51.0001 47.5714ZM51.0001 68.1429C55.2323 68.1429 59.1876 67.7589 62.8662 66.9911C66.5448 66.2232 69.4466 65.0893 71.5716 63.5893V68.1429C71.5716 69.375 70.6519 70.5179 68.8126 71.5714C66.9734 72.625 64.4734 73.4598 61.3126 74.0759C58.1519 74.692 54.7144 75 51.0001 75C47.2859 75 43.8484 74.692 40.6876 74.0759C37.5269 73.4598 35.0269 72.625 33.1876 71.5714C31.3484 70.5179 30.4287 69.375 30.4287 68.1429V63.5893C32.5537 65.0893 35.4555 66.2232 39.1341 66.9911C42.8126 67.7589 46.768 68.1429 51.0001 68.1429ZM51.0001 57.8571C55.2323 57.8571 59.1876 57.4732 62.8662 56.7054C66.5448 55.9375 69.4466 54.8036 71.5716 53.3036V57.8571C71.5716 59.0893 70.6519 60.2321 68.8126 61.2857C66.9734 62.3393 64.4734 63.1741 61.3126 63.7902C58.1519 64.4063 54.7144 64.7143 51.0001 64.7143C47.2859 64.7143 43.8484 64.4063 40.6876 63.7902C37.5269 63.1741 35.0269 62.3393 33.1876 61.2857C31.3484 60.2321 30.4287 59.0893 30.4287 57.8571V53.3036C32.5537 54.8036 35.4555 55.9375 39.1341 56.7054C42.8126 57.4732 46.768 57.8571 51.0001 57.8571ZM51.0001 27C54.7144 27 58.1519 27.308 61.3126 27.9241C64.4734 28.5402 66.9734 29.375 68.8126 30.4286C70.6519 31.4821 71.5716 32.625 71.5716 33.8571V37.2857C71.5716 38.5179 70.6519 39.6607 68.8126 40.7143C66.9734 41.7679 64.4734 42.6027 61.3126 43.2188C58.1519 43.8348 54.7144 44.1429 51.0001 44.1429C47.2859 44.1429 43.8484 43.8348 40.6876 43.2188C37.5269 42.6027 35.0269 41.7679 33.1876 40.7143C31.3484 39.6607 30.4287 38.5179 30.4287 37.2857V33.8571C30.4287 32.625 31.3484 31.4821 33.1876 30.4286C35.0269 29.375 37.5269 28.5402 40.6876 27.9241C43.8484 27.308 47.2859 27 51.0001 27Z"
                    fill="white"
                  />
                </svg>
              </div>
              <div class="header-action-label-container">
                <p>Version {{ storedDatabaseVersion | wholeToFixed }}</p>
              </div>
            </div>

            <div class="header-action-container" (click)="goToOfflineDataPushRoute()">
              <div class="header-action-icon-container">
                <svg
                  width="50"
                  height="50"
                  viewBox="0 0 50 50"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect
                    width="50"
                    height="50"
                    rx="25"
                    [attr.fill]="isDeviceOnline ? primaryColor : '#00000026'"
                  />
                  <path
                    d="M14.4375 21.1875H34.5625C35.3564 21.1875 36 20.5439 36 19.75V16.875C36 16.0811 35.3564 15.4375 34.5625 15.4375H14.4375C13.6436 15.4375 13 16.0811 13 16.875V19.75C13 20.5439 13.6436 21.1875 14.4375 21.1875ZM16.5938 17.2344C17.1892 17.2344 17.6719 17.7171 17.6719 18.3125C17.6719 18.9079 17.1892 19.3906 16.5938 19.3906C15.9983 19.3906 15.5156 18.9079 15.5156 18.3125C15.5156 17.7171 15.9983 17.2344 16.5938 17.2344ZM19.4688 17.2344C20.0642 17.2344 20.5469 17.7171 20.5469 18.3125C20.5469 18.9079 20.0642 19.3906 19.4688 19.3906C18.8733 19.3906 18.3906 18.9079 18.3906 18.3125C18.3906 17.7171 18.8733 17.2344 19.4688 17.2344ZM14.4375 28.375H34.5625C35.3564 28.375 36 27.7314 36 26.9375V24.0625C36 23.2686 35.3564 22.625 34.5625 22.625H14.4375C13.6436 22.625 13 23.2686 13 24.0625V26.9375C13 27.7314 13.6436 28.375 14.4375 28.375ZM16.5938 24.4219C17.1892 24.4219 17.6719 24.9046 17.6719 25.5C17.6719 26.0954 17.1892 26.5781 16.5938 26.5781C15.9983 26.5781 15.5156 26.0954 15.5156 25.5C15.5156 24.9046 15.9983 24.4219 16.5938 24.4219ZM19.4688 24.4219C20.0642 24.4219 20.5469 24.9046 20.5469 25.5C20.5469 26.0954 20.0642 26.5781 19.4688 26.5781C18.8733 26.5781 18.3906 26.0954 18.3906 25.5C18.3906 24.9046 18.8733 24.4219 19.4688 24.4219ZM14.4375 35.5625H34.5625C35.3564 35.5625 36 34.9189 36 34.125V31.25C36 30.4561 35.3564 29.8125 34.5625 29.8125H14.4375C13.6436 29.8125 13 30.4561 13 31.25V34.125C13 34.9189 13.6436 35.5625 14.4375 35.5625ZM16.5938 31.6094C17.1892 31.6094 17.6719 32.0921 17.6719 32.6875C17.6719 33.2829 17.1892 33.7656 16.5938 33.7656C15.9983 33.7656 15.5156 33.2829 15.5156 32.6875C15.5156 32.0921 15.9983 31.6094 16.5938 31.6094ZM19.4688 31.6094C20.0642 31.6094 20.5469 32.0921 20.5469 32.6875C20.5469 33.2829 20.0642 33.7656 19.4688 33.7656C18.8733 33.7656 18.3906 33.2829 18.3906 32.6875C18.3906 32.0921 18.8733 31.6094 19.4688 31.6094Z"
                    fill="white"
                  />
                </svg>
              </div>
            </div>

            <a href="javascript:void(0)" (click)="logout()">
              <img src="/assets/images/logout2.svg" />
            </a>
          </div>
        </div>
      </div>
    </nav>
  </header>

  <main class="main wrapper__main vin-info">
    <section class="vam_barcode_section py-4 h-100">
      <div class="container">
        <div class="vam_barcode_form_container">
          <form class="vam_barcode_form credential px-3" [formGroup]="vin" (submit)="vinSubmit()">
            <div class="row">
              <div class="col-12">
                <div class="form-group">
                  <button type="button" class="btn btn__secondary w-100" (click)="scanStart()">
                    <img src="/assets/images/barcode_scanner.svg" class="barcode_icon mr-2" />
                    <span class="barcode_title" *ngIf="!scannerOn">
                      {{ 'vin_information.Scan_Barcode' | translate }}
                    </span>
                    <span class="barcode_title" *ngIf="scannerOn">
                      {{ 'vin_information.Stop_Scanner' | translate }}
                    </span>
                  </button>

                  <ng-container *ngIf="scannerOn">
                    <zxing-scanner
                      #scanner
                      class="mt-3"
                      [formats]="formats"
                      [(device)]="currentDevice"
                      (camerasFound)="isCamera($event)"
                      (permissionResponse)="permission($event)"
                      (scanSuccess)="scanSuccess($event)"
                    >
                    </zxing-scanner>
                  </ng-container>

                  <!-- <ng-container *ngFor="let device of availableDevices">
                    <pre>
                      {{ device | json }}
                    </pre>
                  </ng-container> -->
                  <!-- <ng-container>
                    {{ currentDevice | json }}
                  </ng-container> -->

                  <ng-container *ngIf="scannerOn">
                    <div class="p-3 error" *ngIf="hasPermission === undefined">
                      <h2 class="fs fs__base font-weight-medium">Waiting for permissions.</h2>

                      <p class="fs fs__sm">
                        If your device does not has cameras, no permissions will be asked.
                      </p>
                    </div>

                    <div class="p-3 error" *ngIf="hasPermission === false">
                      <h2 class="fs fs__base font-weight-medium">
                        You denied the camera permission, we can't scan anything without it.
                      </h2>
                    </div>

                    <div class="p-3 error" *ngIf="hasDevices === undefined">
                      <h2 class="fs fs__base font-weight-medium">Couldn't check for devices.</h2>

                      <p class="fs fs__sm">This may be caused by some security error.</p>
                    </div>

                    <div class="p-3 error" *ngIf="hasDevices === false">
                      <h2 class="fs fs__base font-weight-medium">No devices were found.</h2>

                      <p class="fs fs__sm">
                        I believe your device has no media devices attached to.
                      </p>
                    </div>
                  </ng-container>
                </div>
              </div>

              <span class="vam_label mb-3">{{ 'or' | translate }}</span>

              <div class="col-12">
                <div class="form-group position-relative" (clickOutside)="searchSuccess = false">
                  <input
                    #vinNum
                    type="text"
                    name="vin_number"
                    formControlName="vin_number"
                    placeholder="{{ 'vin_number' | translate }}"
                    class="form-control credential__input-lg p-3"
                    [class.is-invalid]="formData.vin_number.invalid && submitted"
                  />

                  <div class="form-errors" *ngIf="formData.vin_number.invalid && submitted">
                    <p class="form-errors__error" *ngIf="formData.vin_number.errors.required">
                      VIN no. is required.
                    </p>

                    <p class="form-errors__error" *ngIf="formData.vin_number.errors.maxlength">
                      VIN no. should not be more than 21 characters.
                    </p>

                    <p class="form-errors__error" *ngIf="formData.vin_number.errors.pattern">
                      VIN no. should be alphanumerical only.
                    </p>
                  </div>

                  <div
                    #resultBox
                    class="vin-searchResults"
                    *ngIf="vinSearchResults.length && searchSuccess"
                  >
                    <ul class="list-unstyled vin-searchResults__list m-0">
                      <li class="vin-searchResults__item" *ngFor="let result of vinSearchResults">
                        <a
                          href="javascript:void(0)"
                          class="vin-searchResults__link"
                          [class.full]="
                            result['estimara_expiry_date'] &&
                            result['estimara_image'] &&
                            result['mvpi_expiry_date'] &&
                            result['mvpi_image'] &&
                            result['odo_value'] &&
                            result['odo_image'] &&
                            result['vin_image'] &&
                            result['plate_image']
                          "
                          (click)="vinDataSelector(result)"
                        >
                          {{ result['vin_number'] }}
                          <span class="fs fs__sm ml-1">{{ result['plate_number'] }}</span>
                          <span class="fs fs__xs ml-auto">{{ result['updated_at'] }}</span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="form-group">
                  <input
                    type="text"
                    name="plate_number"
                    formControlName="plate_number"
                    placeholder="{{ 'vin_information.plate_number' | translate }}"
                    class="form-control credential__input-lg p-3"
                    [class.is-invalid]="formData.plate_number.invalid && this.submitted"
                  />

                  <div class="form-errors" *ngIf="formData.plate_number.invalid && this.submitted">
                    <p class="form-errors__error" *ngIf="formData.plate_number.errors.required">
                      Plate no. is reqired.
                    </p>

                    <p class="form-errors__error" *ngIf="formData.plate_number.errors.pattern">
                      VIN no. should be alphanumerical only.
                    </p>
                  </div>
                </div>
              </div>

              <div class="col-12">
                <div class="form-group">
                  <button type="button" class="btn btn__secondary w-100" (click)="getPosition()">
                    <img src="/assets/images/place_marker.svg" class="mr-2" />
                    {{ 'vin_information.location_gps' | translate }}
                  </button>
                </div>

                <span class="vam_label mb-3">{{ 'or' | translate }}</span>

                <div class="form-group">
                  <input
                    type="text"
                    name="location"
                    formControlName="location"
                    placeholder="{{ 'vin_information.location_places' | translate }}"
                    autocomplete="off"
                    class="form-control credential__input-lg p-3"
                    ngx-google-places-autocomplete
                    [options]="placesOption"
                    #placesRef="ngx-places"
                    (onAddressChange)="getPlaces($event)"
                  />
                </div>
              </div>
            </div>

            <div class="row mx-n2">
              <div class="col-sm-6 px-2">
                <div class="form-group">
                  <select
                    name="country"
                    formControlName="country"
                    class="form-control credential__select-lg"
                    [style.cursor]="vin.get('country')?.disabled ? 'not-allowed' : 'pointer'"
                    [class.is-invalid]="formData.country.invalid && this.submitted"
                    (change)="getCountryChange($event)"
                  >
                    <option value="">
                      {{ 'vin_information.country' | translate }}
                    </option>

                    <option *ngFor="let country of countries" [value]="country['id']">
                      {{ country['name'] }}
                    </option>
                  </select>

                  <div class="form-errors" *ngIf="formData.city.invalid && this.submitted">
                    <p class="form-errors__error" *ngIf="formData.city.errors.required">
                      Country is reqired.
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-sm-6 px-2">
                <div class="form-group">
                  <select
                    name="state"
                    formControlName="state"
                    class="form-control credential__select-lg"
                    [style.cursor]="vin.get('state')?.disabled ? 'not-allowed' : 'pointer'"
                    [class.is-invalid]="formData.state.invalid && this.submitted"
                    (change)="getStateChange($event)"
                  >
                    <option value="">
                      {{ 'vin_information.state' | translate }}
                    </option>

                    <option [value]="state['id']" *ngFor="let state of states">
                      <ng-container *ngIf="lang === 'en'">
                        {{ state?.['name'] }}
                      </ng-container>
                      <ng-container *ngIf="lang === 'ar'">
                        {{ state?.['name'] }}
                      </ng-container>
                    </option>
                  </select>

                  <div class="form-errors" *ngIf="formData.city.invalid && this.submitted">
                    <p class="form-errors__error" *ngIf="formData.city.errors.required">
                      State is reqired.
                    </p>
                  </div>
                </div>
              </div>
              <div class="col-sm-6 px-2">
                <div class="form-group">
                  <select
                    name="city"
                    formControlName="city"
                    class="form-control credential__select-lg"
                    [style.cursor]="vin.get('city')?.disabled ? 'not-allowed' : 'pointer'"
                    [class.is-invalid]="formData.city.invalid && this.submitted"
                    (change)="getCityChange($event)"
                  >
                    <option value="">
                      {{ 'vin_information.city' | translate }}
                    </option>

                    <option [value]="city['city_id']" *ngFor="let city of cities">
                      <ng-container *ngIf="lang === 'en'">
                        {{ city?.['city_name'] }}
                      </ng-container>
                      <ng-container *ngIf="lang === 'ar'">
                        {{ city?.['city_name'] }}
                      </ng-container>
                    </option>
                  </select>

                  <div class="form-errors" *ngIf="formData.city.invalid && this.submitted">
                    <p class="form-errors__error" *ngIf="formData.city.errors.required">
                      City is reqired.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mx-n2" *ngIf="isVinSelected">
              <div class="col-sm-6">
                <div class="form-group">
                  <div class="custom-control custom-switch m-0">
                    <input
                      type="checkbox"
                      name="is_new"
                      formControlName="is_new"
                      class="custom-control-input"
                      id="is_new"
                      checked
                    />
                    <label class="custom-control-label new-vin-info-label" for="is_new">
                      New
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-12 mt-5">
                <div class="vam_login_btn_container">
                  <button class="btn btn-primary w-100 py-2" [disabled]="submitLoad">
                    {{ 'submit' | translate }}
                    <span
                      class="spinner-grow spinner-grow-sm text-light ml-2"
                      [hidden]="!submitLoad"
                    >
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </section>
  </main>
</div>

<!-- <button (click)="openModal(template)">open modal</button> -->

<ng-template #featureNotAvailableModalTemplate>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Information</h4>
    <button
      type="button"
      class="btn-close close pull-right"
      aria-label="Close"
      (click)="modalRef?.hide()"
    >
      <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <p style="text-align: center; font-size: 18px; color: #434343">
      This feature is not available while you are offline
    </p>
    <br />
    <!-- <button type="button" class="btn btn-primary" (click)="closeModal(1)">Close self</button> -->
    <!-- <button type="button" class="btn btn-primary" (click)="closeModal()">Close all modal</button> -->
  </div>
</ng-template>

<ng-template>
  AIzaSyBlnFMM7LYrLdByQPJopWVNXq0mJRtqb38 --> Not Working AIzaSyAmA2B8tnEbUxUMKQZ03a_Fui3sXs4nHqw
  --> Working
</ng-template>
<app-status></app-status>
